import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accessibility-items',
  templateUrl: './accessibility-items.component.html',
  styleUrls: ['./accessibility-items.component.scss']
})
export class AccessibilityItemsComponent implements OnInit {
  getFontSize: any;
  changeFontSize: number = 0;
  contrastInvert: boolean = true;
  font: number = 16;


  constructor() { }

  ngOnInit() {
    this.getFontSize = () =>
    getComputedStyle(document.documentElement)
      .getPropertyValue('--font-size');
  }

  fontSizeIncrease() {
    if (this.font < 21) {
      this.font = this.font + 0.5;
      document.documentElement.style.fontSize =  this.font + 'px';
    }
  }

  fontSizeDefalult() {
    this.font = 16;
    document.documentElement.style.fontSize =  this.font + 'px';
  }

  fontSizeDecrease() {
    if (this.font > 12) {
      this.font = this.font - 0.5;
      document.documentElement.style.fontSize =  this.font + 'px';
    }
  }

  invertColors() {
    document.documentElement.style.filter = `invert(${this.contrastInvert ? 100 : 0}%)`;
    this.contrastInvert = !this.contrastInvert;
  }
}
